module.exports = __webpack_public_path__ + "img/WinWinSolutions.db85ff6a.png";